import { Navigate, Outlet, useOutletContext } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { hasAnyPermission } from "../../utils/permissions";

export default function RequirePermission({ permissions: requiredPermissions }) {
  const { permissions } = useAuth();
  const outletContext = useOutletContext();
  const canAccess = hasAnyPermission(permissions, ...requiredPermissions);

  if (!canAccess) return <Navigate to="/access-denied" replace />;

  return <Outlet context={outletContext} />;
}
